import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Snackbar, Alert } from "@mui/material";
import {
  ArrowDownLeft,
  ArrowUpRight,
  Banknote,
  Building,
  Calendar,
  FileText,
  Printer,
  Download,
  Receipt,
  CheckCircle,
  RefreshCw,
  ArrowRightLeft,
  Loader2,
} from "lucide-react";
import { Tooltip } from "@mui/material";

import PDCOpenPopup from "./PDCOpenPopup";
import axios from "axios";
import PDCF2Popup from "./PDCF2Popup";
import PDCReceivedPrint from "./PDCReceivedPrint";
import Modal from "../common/CommonModal";
import CreditCustomerList from "../common/CreditCustomerList";

const PDCRecieved = ({ receiveStoreAccounts, searchTerm }) => {
  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [transferDate, setTransferDate] = useState(today);
  const [openPDC, setOpenPDC] = useState(false);
  const [pdcDrModalOpen, setPdcDrModalOpen] = useState(false);
  const [salesmanList, setSalesmanList] = useState([]);
  const [crAccount, setCrAccount] = useState("");
  const [crAccountDesc, setCrAccountDesc] = useState("");
  const [drAccount, setDrAccount] = useState("");
  const [drAccountDesc, setDrAccountDesc] = useState("");
  const [pdcRecievedList, setPDCRecievedList] = useState([]);
  const [sumOfAmounts, setSumOfAmounts] = useState(0);
  const [totalAmounts, setTotalAmounts] = useState(0);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(today);
  const [selectedEntries, setSelectedEntries] = useState([]);
  const [banks, setBanks] = useState([]);
  const [bankName, setBankName] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [isPDCReceivedPrint, setIsPDCReceivedPrint] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (receiveStoreAccounts.length > 0) {
      // Find Credit and Debit accounts based on Scrn_code
      const creditAcc = receiveStoreAccounts.find(
        (item) => item.Scrn_code === "PDC-RCV-C"
      );
      const debitAcc = receiveStoreAccounts.find(
        (item) => item.Scrn_code === "PDC-RCV-D"
      );

      setCrAccount(creditAcc?.ACCOUNT || "");
      setCrAccountDesc(creditAcc?.accdesc || "");
      setDrAccount(debitAcc?.ACCOUNT || "");
      setDrAccountDesc(debitAcc?.accdesc || "");
      fetchRecievedPendingList(creditAcc?.ACCOUNT);
    }
  }, [receiveStoreAccounts]);

  console.log("receiveStoreAccounts:", receiveStoreAccounts);
  console.log("Credit Account:", crAccount);
  console.log("Debit Account:", drAccount);

  useEffect(() => {
    fetchCompanyInfo();
    fetchBanks();
  }, []);

  const fetchRecievedPendingList = async (credAcc) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    // let url = `${apiPaths[0]?.API_CONFIG}/api/CRMDocTransfer/${company_code_from_local_storage}/PDCPENDLIST/R/-/21030001/-/-/-`;
    let url = `${apiPaths[0]?.API_CONFIG
      }/api/CRMDocTransfer/${company_code_from_local_storage}/PDCPENDLIST/R/${bankName ? bankName : "-"
      }/${credAcc}/-/-/-`;
    try {
      const response = await axios.get(url);
      const data = response.data;

      console.log("response data in recieved:", data);
      setPDCRecievedList(data || []);

      const totalSumAmounts = (data || []).reduce((sum, item) => {
        return sum + Number(item.AMOUNT || 0);
      }, 0);
      // console.log('totalSumAmounts:',totalSumAmounts)
      setTotalAmounts(totalSumAmounts);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/COMPANYINFO/-/-`;


    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setStartDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"))
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchBanks = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/BANK/-/-`;


    try {
      const res = await axios.get(apiUrl);
      setBanks(res.data || []);
    } catch (error) {
      console.error("Error fetching bank list:", error);
    }
  };

  const handleSelectToggle = (index, checked) => {
    console.log("index:", index);
    console.log("checked:", checked);

    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = checked;

      // selectedEntries

      const total = pdcRecievedList.reduce((sum, item, i) => {
        if (updated[i]) {
          return sum + Number(item.AMOUNT || 0);
        }
        return sum;
      }, 0);

      setSumOfAmounts(total);

      const selectedItems = pdcRecievedList.filter((_, i) => updated[i]);
      setSelectedEntries(selectedItems);
      console.log("selectedItems:", selectedItems);

      return updated;
    });
  };

  const onTransfer = async () => {
    if (selectedEntries.length === 0) {
      alert("Please Select Atleast one account to transfer");
      return;
    }
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? JSON.parse(localStorage.getItem("currentUser"))
      : [];

    const currentUser = currentUser_from_local_storage?.[0].accessgrp || {};
    let user_id = currentUser || "-";

    // console.log(
    //   "currentUser_from_local_storage:",
    //   currentUser_from_local_storage
    // );
    // console.log("user_id:", user_id);

    const transferPayload = selectedEntries.map((item) => ({
      cmpcode: company_code_from_local_storage,

      operation: "ENTRY",
      JVTYPE: "DB",
      TYPE_NO: item.TYPE_NO || "",
      JVDATE: transferDate || "",
      // CUST_ACC: drAccount || "",
      // ACCDESC: drAccountDesc || "",
      CUST_ACC: crAccount || "",
      ACCDESC: crAccountDesc || "",
      AMOUNT: String(item.AMOUNT || ""),
      DESCRIPT: item.CNAME || "",
      DEPTNO: currentSelectedDepartment || "",
      COMMENTS: "",
      USERID: user_id || "",
      job_code: item.COSTCODE || "",
      sman_code: "",
      costc: item.JVTYPE || "",
      chqno: item.CHQNO || "",
      chqdate: item.CHQDATE ? item.CHQDATE.split("T")[0] : "",
      rate: "1",
      pdcstatus: "",
      pdc_acc: item.PDC_ACC || "",
      reason: "",
      // account: crAccount || "",
      account: drAccount || "",
      jvnum: item.DEPTNO || "",
      ref: item.TYPE_NO || "",
      entry_ref: item.CNAME || "",
      type: "D",
      curno: "",
      curamount: "0",
      user_id: user_id || "",
      accountype: "0",
      depn_p: "0",
      status1: "",
      status: "",
      appl_amt1: "0",
      appl_amt: "0",
      bank: item.BANK || "",
      due_date: null,
      doc_date: null,
      month: "1",
      lpono: "",
      chqprn: "",
      inv_amt: "0",
      inv_fcamt: "0",
      inv_fc: "",
      ccno: "",
      ttref: item.TR_SLNO || "",
      appl_cramt: "0",
      appl_crop: "0",
      appl_dramt: "0",
      pgroup: "",
      upd: "",
      v_amt: "0",
      COSTCODE: item.COSTCODE || "",
    }));
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let apiURL = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMPDCReg`;

    try {
      const response = await axios.post(apiURL, transferPayload, config);
      const data = response.data;
      console.log("transfer data:", data);
      if (data?.result === "Saved") {
        setSnackbarMsg(`Transfer Saved Successfully (VNo: ${data.vno})`);
        setSnackbarType("success");
      } else {
        setSnackbarMsg("Transfer failed — please try again.");
        setSnackbarType("error");
      }
      setSnackbarOpen(true);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 300);
      // fetchRecievedPDC();
      fetchRecievedPendingList(crAccount)
      setSelectedToggle([]);
      setSelectedEntries([]);
      setSumOfAmounts(0);
    } catch (error) {
      console.error("Error while Selected Accounts Transfer", error);
      setSnackbarMsg("Error while transferring accounts!");
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };


  const handleExport = () => {
    // Define columns with field (data key) and headerName (CSV header)
    const columns = [
      { field: "AMOUNT", headerName: "Amount" },
      { field: "CHQNO", headerName: "Chq No" },
      { field: "CHQDATE", headerName: "Chq Date" },
      { field: "BANK", headerName: "Bank" },
      { field: "PDC_ACC", headerName: "Account" },
      { field: "CNAME", headerName: "Name" },
      { field: "JVTYPE", headerName: "JVType" },
      { field: "DEPTNO", headerName: "Dept No" },
      { field: "duedays", headerName: "Due Days" },
      { field: "TR_SLNO", headerName: "TR Sl No" },
      { field: "TYPE_NO", headerName: "Type No" },
      { field: "COSTCODE", headerName: "Cost Code" },
    ];

    exportToCSV(columns, pdcRecievedList, "PDC_Received_List");
  };


  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    // Create header row
    const headerRow = columns.map((col) => col.headerName);

    // Create data rows
    const dataRows = exportData?.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        // Special formatting for date
        if (col.field === "CHQDATE" && value) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      })
    );

    // Combine header + data
    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  const filteredPDCRecievedList = (searchTerm || "").trim()
    ? pdcRecievedList.filter((item) => {
        const term = searchTerm.toLowerCase();
        const name = (item.CNAME || "").toLowerCase();
        const typeNo = (item.TYPE_NO || "").toString().toLowerCase();
        const chqNo = (item.CHQNO || "").toString().toLowerCase();
        const amount = (item.AMOUNT || "").toString().toLowerCase();
        return name.includes(term) || typeNo.includes(term) || chqNo.includes(term) || amount.includes(term);
      })
    : pdcRecievedList;

  return (
    <div className="flex justify-center items-start">
      <div className="w-[25vw] h-[77vh]  bg-white shadow-md border-r border-gray-200 p-3 space-y-5">
        <div className="space-y-4">
          {/* Cr A/C */}
          <div className="flex justify-left items-center gap-1 ">
            <div className="w-[160px]">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <ArrowUpRight className="w-4 h-4 mr-2 text-gray-600" />
                Bank
              </label>
              <input
                value={crAccount}
                onChange={(e) => setCrAccount(e.target.value)}
                readOnly
                placeholder="Enter Cr A/C..."
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200"
              />
            </div>

            {/* Bank */}
            <Tooltip title={crAccountDesc} arrow>
              <div className="flex-1">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  {/* <Building className="w-4 h-4 mr-2 text-gray-600" /> */}(
                  Cr )
                </label>
                <input
                  value={crAccountDesc}
                  placeholder="Enter Bank Name..."
                  className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200"
                />
              </div>
            </Tooltip>
          </div>
          {/* Dr A/C */}
          <div className="flex justify-left items-center gap-1 ">
            <div className="w-[160px]">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <ArrowDownLeft className="w-4 h-4 mr-2 text-gray-600" />
                PDC Account
              </label>
              <input
                value={drAccount}
                onChange={(e) => setDrAccount(e.target.value)}
                placeholder="Enter Dr A/C..."
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200 bg-gray-100"
                onKeyDown={(e) => {
                  if (e.key === "F2") {
                    // fetchAccountList("ALL");
                    // setSelectedRowIndex(index);
                    setPdcDrModalOpen(true);
                    // setDropdownOpenIndex(null);
                  }
                }}
              />
            </div>
            {/* PDC Account */}
            <Tooltip title={drAccountDesc} arrow>
              <div className="flex-1">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  {/* <Receipt className="w-4 h-4 mr-2 text-gray-600" /> */}( Dr
                  )
                </label>
                <input
                  value={drAccountDesc}
                  placeholder="Enter PDC Account..."
                  className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200"
                />
              </div>
            </Tooltip>
          </div>

          {/* Manage Opening PDC Button */}
          {/* <div className="py-2">
            <button
              onClick={() => setOpenPDC(true)}
              className="w-full flex items-center justify-center gap-2 
               bg-purple-500 
               text-white font-semibold py-2.5 px-4 
               rounded-xl shadow-md hover:shadow-lg 
               hover:from-purple-600 hover:to-purple-700
               active:scale-95 transition-all duration-200
               focus:outline-none focus:ring-2 focus:ring-purple-300 text-sm"
            >
              <CheckCircle className="w-5 h-5 text-white" />
              Manage Opening PDC
            </button>
          </div> */}

          {/* Transfer Date */}
          <div className="flex justify-center items-center gap-1">
            <div>
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                Transfer Date
              </label>
              <input
                type="date"
                value={transferDate}
                onChange={(e) => setTransferDate(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
              />
            </div>

            {/* Reference */}
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <FileText className="w-4 h-4 mr-2 text-gray-600" />
                Reference
              </label>

              <input
                placeholder="Enter Reference..."
                className="w-full px-3 py-2.5 text-xs bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-gray-500 
                   placeholder-gray-400 transition-all duration-200"
              />
            </div>
          </div>

          {/* Action Buttons: Print & Export */}
          <div className="flex gap-3 py-2">
            <button
              onClick={() => setIsPDCReceivedPrint(true)}
              className="flex-1 flex items-center justify-center gap-2 
                         bg-[#F87315] text-white 
                         font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                         transform hover:scale-[1.02] active:scale-100 
                         transition-all duration-200 text-sm"
            >
              <Printer className="w-4 h-4" />
              Print
            </button>

            <button
              onClick={handleExport}
              className="flex-1 flex items-center justify-center gap-2 
                         bg-[#ED3F5E] text-white 
                         font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                         transform hover:scale-[1.02] active:scale-100 
                         transition-all duration-200 text-sm"
            >
              <Download className="w-4 h-4" />
              Export
            </button>
          </div>
          <div className="flex">
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Bank
              </label>
              <select
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Bank...</option>
                {banks.map((bank) => (
                  <option key={bank.Bank_ID} value={bank.Bank_ID}>
                    {bank.Bank_Name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex hidden items-center gap-3 mt-6 ml-4">
              <label className="text-xs font-semibold ">Apply Filter</label>
              <label className="relative inline-block w-[3.5em] h-[1.95em]">
                <input
                  type="checkbox"
                  className="peer sr-only"
                  checked={isApplyFilter}
                  onChange={(e) => setIsApplyFilter(e.target.checked)}
                />
                <span
                  className="
                                      absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                                      after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                                      after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                                      after:transition-all after:duration-300 after:ease-in-out
                                      after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                                      peer-checked:bg-blue-500
                                      peer-checked:after:translate-x-[1.5em]
                                      peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                                      peer-active:after:w-[3em]
                                      peer-checked:peer-active:after:translate-x-[0.5em]
                                    "
                ></span>
              </label>
            </div>
          </div>

          {isApplyFilter && (
            <div className="flex justify-center items-center gap-1">
              <div className="flex-1">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                  Start Date
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
                />
              </div>
              <div className="flex-1">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                  End Date
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
                />
              </div>
            </div>
          )}

          {/* PDC to TRFR */}
          <div>
            <label className="flex items-center font-semibold text-gray-700 mb-1.5">
              <Banknote className="w-4 h-4 mr-2 text-gray-700" />
              <span className="text-xs">PDC to TRFR:</span>
              <span className="ml-2 text-md font-bold text-green-600">
                {sumOfAmounts}
              </span>
            </label>
            {/* < className="w-4 h-4 mr-2 text-gray-600" /> */}

            {/* <input
              value={sumOfAmounts}
              placeholder="Enter PDC to TRFR..."
              className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-orange-500 
                   placeholder-gray-400 transition-all duration-200"
            /> */}
          </div>

          {/* PDC In Hand */}
          <div>
            <label className="flex items-center font-semibold text-gray-700 mb-1.5">
              <CheckCircle className="w-4 h-4 mr-2 text-gray-700" />
              <span className="text-xs">PDC In Hand:</span>
              <span className="ml-2 text-md font-bold text-red-600">
                {totalAmounts.toFixed(3)}
              </span>
            </label>

            {/* <input
            value={totalAmounts}
              placeholder="Enter PDC Recieved..."
              className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-green-500 
                   placeholder-gray-400 transition-all duration-200"
            /> */}
          </div>

          <div className="flex gap-3 py-2">
            <button
              onClick={() => fetchRecievedPendingList(crAccount)}
              className="flex-1 flex items-center justify-center gap-2 
               bg-[#879C58] text-white 
               font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
               transform hover:scale-[1.02] active:scale-100 
               transition-all duration-200 text-sm"
            >
              <RefreshCw className="w-4 h-4" />
              Refresh
            </button>

            <Tooltip
              title={
                selectedEntries.length === 0
                  ? "Select entries to enable transfer"
                  : "Transfer selected entries"
              }
              arrow
              placement="top"
            >
              <button
                onClick={onTransfer}
                disabled={selectedEntries.length === 0}
                className={`flex-1 flex items-center justify-center gap-2 
        font-medium px-4 py-2.5 rounded-lg shadow transition-all duration-200 text-sm
        ${selectedEntries.length === 0
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-[#03CFFF] text-white hover:shadow-md transform hover:scale-[1.02] active:scale-100"
                  }`}
              >
                <ArrowRightLeft className="w-4 h-4" />
                Transfer
              </button>
            </Tooltip>
          </div>
        </div>
      </div>



      <div className="w-[1200px] overflow-auto h-[77vh] shadow-md scrollbar-auto-hide relative">
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-20">
            <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
        )}
        <div className="overflow-auto w-[70vw] scrollbar-auto-hide">
          <table className="relative  text-xs border-collapse">
            <thead>
              <tr>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 z-10">
                  Select
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Amount
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Chq No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Chq Date
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Bank
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Account
                </th>

                <th className="bg-gray-100 w-60 font-normal sticky top-0 border px-2 py-1">
                  Name
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  JVType
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Dept No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Due Days
                </th>

                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  TR Sl No
                </th>

                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Type No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Cost Code
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredPDCRecievedList?.length > 0 ? (
                filteredPDCRecievedList.map((acc, index) => (
                  <tr key={acc?.INV || index} className="text-xs">
                    <td className="border w-[100] text-center bg-white">
                      <label className="relative inline-block w-[3.5em] h-[2.1em]">
                        <input
                          type="checkbox"
                          className="peer sr-only"
                          checked={!!selectedToggle[index]}
                          onChange={(e) =>
                            handleSelectToggle(index, e.target.checked)
                          }
                        />
                        <span
                          className="
                                      absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                                      after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                                      after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                                      after:transition-all after:duration-300 after:ease-in-out
                                      after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                                      peer-checked:bg-blue-500
                                      peer-checked:after:translate-x-[1.5em]
                                      peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                                      peer-active:after:w-[3em]
                                      peer-checked:peer-active:after:translate-x-[0.5em]
                                    "
                        ></span>
                      </label>
                    </td>



                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.AMOUNT ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.CHQNO ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.CHQDATE
                        ? dayjs(acc.CHQDATE).format("DD/MM/YYYY")
                        : "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-left">
                      {acc?.BANK ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.PDC_ACC ?? "-"}
                    </td>

                    <td className="border w-60 bg-white px-2 py-1 text-left">
                      {acc?.CNAME ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.JVTYPE ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.DEPTNO ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.duedays ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.TR_SLNO ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.TYPE_NO ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.COSTCODE ? acc?.COSTCODE : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-4 text-gray-500">
                    No outstanding data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {openPDC && <PDCOpenPopup setOpenPDC={setOpenPDC} data={"12040036"} />}
      {/* {pdcDrModalOpen && <PDCF2Popup setPdcDrModalOpen={setPdcDrModalOpen} />} */}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
      {isPDCReceivedPrint && (
        <div className="m-6">
          <PDCReceivedPrint
            pdcReceivedPrintDataFromAPI={pdcRecievedList}
            isPDCReceivedPrint={isPDCReceivedPrint}
            setIsPDCReceivedPrint={setIsPDCReceivedPrint}
          />
        </div>
      )}
      <Modal
        isOpen={pdcDrModalOpen}

        onClose={() => setPdcDrModalOpen(false)}
        title="Select Dr PDC Account"
        size="xxl"
      >
        {/* <PDCF2Popup setPdcDrModalOpen={setPdcDrModalOpen} /> */}
        <CreditCustomerList
          onClose={() => setPdcDrModalOpen(false)}
          // selectedAccount={drAccount}
          handleCustomerSelect={(account) => {
            console.log("Account", account)
            setDrAccount(account.ACCOUNT);
            setDrAccountDesc(account.DESCRIPTION)
            setPdcDrModalOpen(false);
          }}

        />
      </Modal>
    </div>
  );
};

export default PDCRecieved;
